import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const StateButton = (props) => {
    const { text, bsStyle = 'primary', className, onClick = () => { }, href } = props;
    // In case a href is given, render a link instead
    if (href) {
        return (_jsx("a", Object.assign({ className: classNames('margin-top-15', className), href: href, onClick: onClick }, { children: text })));
    }
    const buttonClassNames = classNames('btn', 'margin-top-10', `btn-${bsStyle}`, className);
    return (_jsx("button", Object.assign({ className: buttonClassNames, type: 'button', onClick: onClick }, { children: text })));
};
export default StateButton;
